<div *transloco="let t" class="flex h-full flex-col gap-4 border-r">
  <ul class="flex h-full flex-col gap-8 p-4" data-cy="dtis-slim-navbar-baselinks">
    <li>
      <a [routerLink]="['/']" class="flex items-center gap-2">
        <mat-icon>home</mat-icon>
        @if (expanded()) {
        <span routerLinkActive="text-primary">{{ t('home') }}</span>
        }
      </a>
    </li>
    @for (item of routes(); track $index) {
    <li>
      <a [routerLink]="['/', item.route]" class="flex items-center gap-2">
        <mat-icon>{{ item.icon }}</mat-icon>
        @if (expanded()) {
        <span routerLinkActive="text-primary">{{ t(item.name) }}</span>
        }
      </a>
    </li>
    }
  </ul>

  <ul class="flex flex-col items-center justify-self-end">
    <li class="hover:bg-surface flex items-center justify-center rounded-full" ngClass="{'bg-surface h-8 w-8': !expanded}">
      <a [routerLink]="['/', settingsRoute()]" class="flex h-full w-full items-center p-2">
        <mat-icon>settings</mat-icon>
      </a>
    </li>
  </ul>
</div>
